import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Lock, Sparkles } from 'lucide-react';

/**
 * PremiumLock - Componente para bloquear/desbloquear secciones según el plan.
 * 
 * Props:
 * - access: Boolean - Si true, renderiza children normalmente
 * - featureName: String - Nombre de la característica bloqueada (para mostrar)
 * - children: ReactNode - Contenido protegido
 * - onUpgrade: Function (optional) - Callback al hacer click en "Mejorar Plan"
 */
const PremiumLock = ({ 
  access, 
  featureName = 'Esta función', 
  children,
  onUpgrade,
  className = ''
}) => {
  const navigate = useNavigate();
  
  // Si tiene acceso, renderizar normalmente
  if (access) {
    return <>{children}</>;
  }

  const handleUpgrade = () => {
    if (onUpgrade) {
      onUpgrade();
    } else {
      // Navegar a la página de suscripción
      navigate('/app/suscripcion');
    }
  };

  // Renderizar placeholder bloqueado
  return (
    <div className={`relative ${className}`}>
      {/* Contenido difuminado de fondo */}
      <div className="blur-sm opacity-50 pointer-events-none select-none">
        {children}
      </div>
      
      {/* Overlay con candado */}
      <div className="absolute inset-0 bg-white/80 backdrop-blur-[2px] flex items-center justify-center rounded-xl">
        <div className="text-center p-6 max-w-sm">
          {/* Icono de candado */}
          <div className="inline-flex items-center justify-center w-16 h-16 rounded-full bg-gradient-to-br from-[#2a9d8f]/10 to-[#2a9d8f]/20 mb-4">
            <Lock className="w-8 h-8 text-[#2a9d8f]" />
          </div>
          
          {/* Título */}
          <h3 className="text-lg font-semibold text-gray-800 mb-2">
            {featureName}
          </h3>
          
          {/* Descripción */}
          <p className="text-sm text-gray-500 mb-4">
            Esta función está disponible en planes superiores.
          </p>
          
          {/* Botón de upgrade */}
          <button
            onClick={handleUpgrade}
            className="inline-flex items-center gap-2 px-5 py-2.5 bg-[#2a9d8f] hover:bg-[#23877a] 
                       text-white font-medium rounded-lg transition-all duration-200 
                       shadow-md hover:shadow-lg transform hover:-translate-y-0.5"
          >
            <Sparkles className="w-4 h-4" />
            Mejorar Plan
          </button>
        </div>
      </div>
    </div>
  );
};

export default PremiumLock;
